export default {"src":"/_next/static/media/order-eye.fb3c1dd3.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};